import { APIBASE } from '../config.js';
export const sum = (a, b) => a + b;
export const applyTargetValue = (fn) => (e) => fn(e.target.value);
export const diff = (original, updated) => {
    const added = [];
    const removed = [];
    for (const entry of original) {
        if (updated.indexOf(entry) === -1) {
            removed.push(entry);
        }
    }
    for (const entry of updated) {
        if (original.indexOf(entry) === -1) {
            added.push(entry);
        }
    }
    return { added, removed };
};
export const round = (n, decimalPlaces) => Math.round(n * 10 ** decimalPlaces) / 10 ** decimalPlaces;
export const toPercent = (n) => round(n * 100, 4);
export const toDecimal = (n) => round(n, 4) / 100;
export const optionalParseNumber = (str) => {
    const parsed = Number(str);
    return isNaN(parsed) ? str : parsed;
};
export const toLink = (id, name = '') => {
    return `${APIBASE}/files/${id}/${name}`;
};
//# sourceMappingURL=index.js.map